import TransportLocation from "../types/TransportLocation";

/**
 * Gets the location ID to send to the API
 * If the location has parentLocation, returns the parent ID
 * If not, returns the original ID
 * @param locationId Location ID
 * @param location Location object
 * @returns Location ID to send (can be from parent if it exists)
 */
export function getLocationIdToSend(
    location?: TransportLocation
): number | undefined {
    if (!location) return undefined;

    if (location?.parentLocation?.id) {
        return location.parentLocation.id;
    }
    
    return location.id;
}

